<script setup>
import { ref, computed, onMounted, inject } from 'vue';
import { useMainStore } from '../../../stores/index';
import { AxiosAPI } from '@/axios';
import ModalTask from './ModalTask.vue';
import ModalCreateTask from './ModalCreateTask.vue';
import moment from 'moment';

const Store = useMainStore();
const emitter = inject('emitter');

const ModalTaskRef = ref(null);
const ModalCreateTaskRef = ref(null);

const dataAtual = ref(new Date());
const days = ref({
  Segunda: [],
  Terça: [],
  Quarta: [],
  Quinta: [],
  Sexta: [],
  Sábado: [],
  Domingo: []
});
const allDays = ref({
  Segunda: [],
  Terça: [],
  Quarta: [],
  Quinta: [],
  Sexta: [],
  Sábado: [],
  Domingo: []
});

const draggedTask = ref(null);
const sourceDay = ref(null);
const TaskName = ref('');
const taskInputsVisibility = ref({});
const loading = ref(false);
const NewOrdem = ref([]);
const dateNow = ref('');
const dateSearch = ref('');
const weekend_expanded = ref(false);
const viewMode = ref('weekly');

const tasksByStatus = computed(() => {
  const allTasks = [
    ...(days.value.Segunda || []),
    ...(days.value.Terça || []),
    ...(days.value.Quarta || []),
    ...(days.value.Quinta || []),
    ...(days.value.Sexta || []),
    ...(days.value.Sábado || []),
    ...(days.value.Domingo || [])
  ];
  return {
    start: allTasks.filter(t => t.situation === '1'),
    executed: allTasks.filter(t => t.situation === '2'),
    bloqued: allTasks.filter(t => t.situation === '4'),
    finish: allTasks.filter(t => t.situation === '3')
  };
});

const startOfWeek = computed(() => {
  if (!dateSearch.value) {
    return moment(new Date()).startOf('isoWeek');
  }
  return moment(dateSearch.value).startOf('isoWeek');
});

const formatDateWeekMobile = computed(() => {
  const weekdays = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];
  return weekdays.reduce((acc, day) => {
    acc[day] = days.value[day] || [];
    return acc;
  }, {});
});

const formatDateWeek = computed(() => {
  const weekdays = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta'];
  return weekdays.reduce((acc, day) => {
    acc[day] = days.value[day] || [];
    return acc;
  }, {});
});

const formatDateWeekend = computed(() => {
  const weekdays = ['Sábado', 'Domingo'];
  return weekdays.reduce((acc, day) => {
    acc[day] = days.value[day] || [];
    return acc;
  }, {});
});

const isCurrentWeek = computed(() => {
  const currentWeekStart = moment().startOf('isoWeek').format('YYYY-MM-DD');
  const selectedWeekStart = moment(startOfWeek.value).format('YYYY-MM-DD');
  return currentWeekStart === selectedWeekStart;
});

const getDateForDay = (index) => startOfWeek.value.clone().add(index, 'days').format('DD');

const isToday = (index) => {
  const dayOfWeek = startOfWeek.value.clone().add(index, 'days').format('YYYY-MM-DD');
  const today = new Date().toISOString().split('T')[0];
  return dayOfWeek === today;
};

const getDate = (index) => startOfWeek.value.clone().add(index, 'days').format('MM/DD/YYYY');
const getDatebr = (index) => startOfWeek.value.clone().add(index, 'days').format('YYYY/MM/DD');

const formatdateToEdit = (value) => {
  moment.locale('en-us');
  return moment(value).format('yyyy-MM-DD');
};

const getTask = async () => {
  try {
    const resp = await AxiosAPI.get('/api/tasks?reference_day=' + formatdateToEdit(dateSearch.value), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + Store.accessToken
      }
    });
    days.value = {
      Segunda: resp.data.tasks.monday || [],
      Terça: resp.data.tasks.tuesday || [],
      Quarta: resp.data.tasks.wednesday || [],
      Quinta: resp.data.tasks.thursday || [],
      Sexta: resp.data.tasks.friday || [],
      Sábado: resp.data.tasks.saturday || [],
      Domingo: resp.data.tasks.sunday || []
    };
    allDays.value = { ...days.value };
  } catch (error) {
    console.error('Erro ao carregar tarefas:', error);
  }
};

const selectDay = (value) => {
  if (ModalTaskRef.value) {
    ModalTaskRef.value.openTask(value);
  }
};

const CreateTask = (value, type) => {
  if (ModalCreateTaskRef.value) {
    ModalCreateTaskRef.value.openCreateTask(getDate(value), type);
  }
};

const onDragStart = (task, day) => {
  draggedTask.value = task;
  sourceDay.value = day;
};

const onDragOverTask = (targetTask) => {
  if (!draggedTask.value || draggedTask.value.id === targetTask.id) return;
  if (!sourceDay.value || !allDays.value[sourceDay.value]) return;

  const dayTasks = allDays.value[sourceDay.value];
  const draggedIndex = dayTasks.findIndex((t) => t.id === draggedTask.value.id);
  const targetIndex = dayTasks.findIndex((t) => t.id === targetTask.id);

  if (draggedIndex !== -1 && targetIndex !== -1) {
    dayTasks.splice(draggedIndex, 1);
    dayTasks.splice(targetIndex, 0, draggedTask.value);
    NewOrdem.value = dayTasks;
    syncDays();
  }
};

const onDragOver = (event) => {
  event.preventDefault();
};

const onDrop = (targetDay, taskDrop, tasks, index) => {
  const dayMap = {
    Segunda: '1',
    Terça: '2',
    Quarta: '3',
    Quinta: '4',
    Sexta: '5',
    Sábado: '6',
    Domingo: '7',
    metas: '8'
  };
  const dataValor = dayMap[targetDay] || '0';

  if (dataValor !== '0' && draggedTask.value && draggedTask.value.weekday !== dataValor) {
    if (!sourceDay.value) return;

    allDays.value[sourceDay.value] = allDays.value[sourceDay.value].filter(
      (t) => t.id !== draggedTask.value.id
    );

    if (allDays.value[targetDay]) {
      allDays.value[targetDay].push(draggedTask.value);
    }

    syncAroundDays();

    AxiosAPI.put(`/api/tasks/${draggedTask.value.id}`, {
      date: getDatebr(index)
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Store.accessToken}`
      }
    }).then(() => {
      getTask();
    }).catch((error) => {
      console.error('Erro ao atualizar tarefa:', error);
      if (allDays.value[sourceDay.value]) {
        allDays.value[sourceDay.value].push(draggedTask.value);
      }
    });

    draggedTask.value = null;
    sourceDay.value = null;
  }

  if (taskDrop && NewOrdem.value.length) {
    const dayTasks = NewOrdem.value.map((tarefa, idx) => ({
      ...tarefa,
      ordem: idx
    }));

    const ordem = dayTasks.map(t => t.id);
    AxiosAPI.patch('/api/tasks/change-order', {
      weekday: dayTasks[0].weekday,
      tasks: ordem
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Store.accessToken}`
      }
    }).then(() => {
      getTask();
    }).catch((error) => {
      console.error('Erro ao atualizar ordem:', error);
    });
  }
};

const onDropStatus = (targetSituation) => {
  if (!draggedTask.value) return;

  if (draggedTask.value.situation !== targetSituation) {
    AxiosAPI.put(`/api/tasks/${draggedTask.value.id}`, {
      situation: targetSituation
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Store.accessToken}`
      }
    }).then(() => {
      getTask();
    }).catch((error) => {
      console.error('Erro ao atualizar situação da tarefa:', error);
    });

    draggedTask.value = null;
    sourceDay.value = null;
  }
};

const syncAroundDays = () => {
  days.value = {
    Segunda: [...allDays.value.Segunda],
    Terça: [...allDays.value.Terça],
    Quarta: [...allDays.value.Quarta],
    Quinta: [...allDays.value.Quinta],
    Sexta: [...allDays.value.Sexta],
    Sábado: [...allDays.value.Sábado],
    Domingo: [...allDays.value.Domingo]
  };
};

const syncDays = () => {
  days.value = {
    Segunda: [...allDays.value.Segunda],
    Terça: [...allDays.value.Terça],
    Quarta: [...allDays.value.Quarta],
    Quinta: [...allDays.value.Quinta],
    Sexta: [...allDays.value.Sexta],
    Sábado: [...allDays.value.Sábado],
    Domingo: [...allDays.value.Domingo]
  };
};

const handleTaskEdit = () => {
  getTask();
};

const getSemanaDoMes = (data) => {
  const date = new Date(data);
  const primeiroDiaDoMes = new Date(date.getFullYear(), date.getMonth(), 1);
  const diff = (date - primeiroDiaDoMes) / (1000 * 60 * 60 * 24);
  const semana = Math.ceil((diff + 1) / 7);

  dateSearch.value = date;
  dateNow.value = `${semana}ª semana de ${date.toLocaleString('pt-BR', { month: 'long' })}/${date.getFullYear()}`;
  getTask();
};

const avancarSemana = () => {
  dataAtual.value.setDate(dataAtual.value.getDate() + 7);
  getSemanaDoMes(dataAtual.value);
};

const voltarSemana = () => {
  dataAtual.value.setDate(dataAtual.value.getDate() - 7);
  getSemanaDoMes(dataAtual.value);
};

const resetWeeks = () => {
  dataAtual.value = new Date();
  getSemanaDoMes(dataAtual.value);
};

onMounted(() => {
  getSemanaDoMes(dataAtual.value);
  if (emitter) {
    emitter.on('KanbanUpdated', () => {
      getTask();
    });
  }
});
</script>

<style scoped>
.kanban-view-toggle {
  display: inline-flex;
  border: 1.5px solid #F1860B;
  border-radius: 6px;
  overflow: hidden;
  background-color: #FAFAFA;
}

.kanban-view-btn {
  border: none;
  background: transparent;
  padding: 8px 16px;
  font-size: 15px;
  font-weight: 500;
  color: #F1860B;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

.kanban-view-btn i {
  color: #F1860B;
}

.kanban-view-btn--active {
  background-color: #F1860B !important;
  color: #FFFFFF !important;
  font-weight: 600;
}

.kanban-view-btn--active i {
  color: #FFFFFF !important;
}

.kanban {
  display: flex;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 12px;
}

.days {
  display: flex;
  gap: 12px;
  flex: 1;
  min-width: max-content;
  width: 100%;
}

.board-columns {
  display: flex;
  gap: 12px;
  width: 100%;
  flex: 1;
}

.kanban-collum {
  display: block;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  flex: 1;
  min-width: 252px;
  min-height: 687px;
  background-color: #E9ECEF;
}

.board-column {
  flex: 1;
  min-width: 260px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px;
  background-color: #E9ECEF;
  min-height: 687px;
}

.days-weekend {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 252px;
  width: 252px;
  flex-shrink: 0;
}

.kanban-collum-weekend {
  display: block;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  min-height: 338px;
  background-color: #E9ECEF;
}

.days-weekend-no-expand {
  display: flex;
  flex-direction: column;
  width: 70px;
  min-width: 70px;
  flex-shrink: 0;
}

.days-weekend-no-expand .kanban-collum-weekend {
  min-height: 687px;
  padding: 16px 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.kanban-task-list {
  background-color: #E9ECEF;
  margin-bottom: 16px;
  width: 100%;
}

.task {
  background-color: #FFFFFF;
  width: 100%;
  height: auto;
  border-radius: 5px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.column-header-text {
  font-size: 15px !important;
  font-weight: bold;
}

.task-title {
  font-size: 15px !important;
  font-weight: 500;
  line-height: 1.4;
  color: #495057;
}

.tag-text {
  font-size: 11px !important;
  font-weight: bold !important;
  text-transform: uppercase;
}

.todayBorder {
  border: 2px solid orange;
}

.move-enter-active, .move-leave-active {
  transition: transform 0.3s;
}
.move-enter, .move-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

@media screen and (max-width: 625px) {
  .kanban {
    width: 100%;
    display: block;
  }
  .kanban-collum, .board-column {
    width: 100%;
    min-width: 100%;
    min-height: 200px;
    margin-bottom: 15px;
  }
  .days, .board-columns {
    display: block;
    width: 100%;
    min-width: 100%;
  }
  .kanban-task-list {
    display: flex;
    overflow-x: auto;
    padding-bottom: 10px;
  }
  .task {
    width: 85vw;
    min-width: 260px;
    flex-shrink: 0;
    margin-right: 0.75rem;
  }
}
</style>

<template>
<div>
  <div v-if="!Store.mobile" class="w-100">
    <ModalTask ref="ModalTaskRef" @taskDescription="handleTaskEdit"/>
    <ModalCreateTask ref="ModalCreateTaskRef" @CreateTask="handleTaskEdit"/>

    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <i class="fa-solid fa-chevron-left mr-2" style="font-size: 20px; cursor:pointer" @click="voltarSemana()"></i>
        <i class="fa-solid fa-chevron-right mr-3" style="font-size: 20px; cursor:pointer" @click="avancarSemana()"></i>
        <span class="font-docs mr-3" style="font-size: 20px"><b>{{dateNow}}</b></span>
        <span :class="['font-docs', isCurrentWeek ? 'text-black' : 'Color-Docs']" style="font-size: 20px; cursor:pointer" @click="resetWeeks()">Semana atual</span>
        <i :class="['fa-solid fa-arrows-rotate ml-1', isCurrentWeek ? 'text-black' : 'Color-Docs']" style="font-size: 20px; cursor:pointer" @click="resetWeeks()"></i>
      </div>

      <div class="kanban-view-toggle">
        <button
          :class="['kanban-view-btn', viewMode === 'weekly' ? 'kanban-view-btn--active' : '']"
          @click="viewMode = 'weekly'"
        >
          <i class="fa-regular fa-calendar mr-2"></i> Visão semanal
        </button>
        <button
          :class="['kanban-view-btn', viewMode === 'board' ? 'kanban-view-btn--active' : '']"
          @click="viewMode = 'board'"
        >
          <i class="fa-solid fa-list-check mr-2"></i> Quadro de tarefas
        </button>
      </div>
    </div>

    <template v-if="viewMode === 'weekly'">
      <div v-if="weekend_expanded" class="font-docs text-start d-flex justify-content-end w-100 mb-2">
        <div style="width: 35px;height: 35px;background-color: orange;border-radius: 50%;align-items: center;display: flex;justify-content: center; cursor:pointer" @click="weekend_expanded = !weekend_expanded">
          <span class="font-docs"> <b><i class="fa fa-times text-white" aria-hidden="true"></i></b></span>
        </div>
      </div>
      <div class="kanban">
          <div class="days">
            <div v-for="(tasks, day, index) in formatDateWeek" :key="day"
              class="kanban-collum"
              :class="isToday(index) ? 'todayBorder' : ''"
              @dragover.prevent="onDragOver"
              @drop="onDrop(day, false, tasks, index)"
              >
                <div class="font-docs text-start d-flex justify-content-between w-100 mb-2" style="align-items: baseline;">
                  <div class="ml-2 column-header-text">
                    <span class="mr-1" style="color:#6C757D;"><b>{{ day.slice(0, 3) }}</b></span>
                    <span><b>{{ getDateForDay(index) }}</b></span>
                    <span v-if="isToday(index)" class="font-docs ml-1"> <b>(hoje)</b></span>
                  </div>
                  <div class="mr-1">
                    <i class="fa-solid fa-plus" style="color:#6C757D; font-size: 14px; cursor:pointer" @click="CreateTask(index, 0)"></i>
                  </div>
                </div>
              <div class="kanban-task-list">
                <transition-group name="move" tag="div">
                  <div
                    v-for="(task, tIndex) in tasks"
                    :key="tIndex"
                    class="task font-docs mb-2"
                    style="cursor: pointer;"
                    @click="selectDay(task)"
                    @dragstart="onDragStart(task, day)"
                    @dragover.prevent="onDragOverTask(task)"
                    @drop="onDrop(task, true)"
                    draggable="true"
                  >
                  <div v-if="task.situation" class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <i v-if="task.situation !== '3'" class="fa-regular fa-circle-check mr-2" style="font-size: 12px;"></i>
                      <i v-if="task.situation === '3'" class="fa-solid fa-circle-check" style="font-size: 12px;"></i>
                      <Tag v-if="task.situation === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                        <span class="font-docs tag-text">À iniciar</span>
                      </Tag>
                      <Tag v-if="task.situation === '2'" rounded style='background-color: #CFF4FC;color: #087990;'>
                        <span class="font-docs tag-text">Em andamento</span>
                      </Tag>
                      <Tag v-if="task.situation === '4'" rounded style='background-color: #F8D7DA;color: #842029;'>
                        <span class="font-docs tag-text">Bloqueada</span>
                      </Tag>
                      <Tag v-if="task.situation === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                        <span class="font-docs tag-text">Concluída</span>
                      </Tag>
                    </div>
                    <div>
                      <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                      <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                      <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                    </div>
                  </div>
                  <div class="mb-3 mt-2 task-title">
                    <span v-if="task.situation !== '3'">{{ task.title }}</span>
                    <span v-if="task.situation === '3'"><s>{{ task.title }}</s></span>
                  </div>

                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center">
                        <div v-if="task.attachments && task.attachments.length >= 1" class="mr-2">
                          <i class="fa-solid fa-file-invoice mr-1" style="color:#ADB5BD; font-size: 12px;"></i>
                          <span style="color:#ADB5BD; font-size: 9px; font-weight: bold;">{{ task.attachments.length }}</span>
                        </div>
                      </div>

                      <div class="d-flex" v-if="task.users">
                        <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                            :key="user.id || uIdx"
                            :src="$userAvatar(user.path_image)"
                            alt="Avatar"
                            v-tooltip.top="user.name"
                            :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">

                        <div v-if="task.users.length > 2"
                            class="d-flex align-items-center justify-content-center"
                            style="width:20px; height: 20px; font-size: 9px; font-weight: bold; border:1px solid #3D8BFD; border-radius: 50%; background-color: #E7F1FF;">
                          <span class="font-docs" style="color: #3D8BFD;">+{{ task.users.length - 2 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>

          <div v-if="!weekend_expanded" class="days-weekend-no-expand" style="margin-left: 1rem;">
            <div class="kanban-collum-weekend">
              <div class="font-docs text-start d-flex justify-content-center w-100 mb-2">
                <div style="width: 35px;height: 35px;background-color: orange;border-radius: 50%;align-items: center;display: flex;justify-content: center; cursor:pointer" @click="weekend_expanded = !weekend_expanded">
                  <span class="font-docs"> <i class="fa fa-bars text-white" aria-hidden="true"></i></span>
                </div>
              </div>
              <div class="kanban-task-list mt-4 text-center">
                <div class="mb-2"><span class="font-docs column-header-text" style="color: #6C757D;">SAB</span></div>
                <div><span class="font-docs column-header-text" style="color: #6C757D;">DOM</span></div>
              </div>
            </div>
          </div>

          <div v-if="weekend_expanded" class="days-weekend" style="margin-left: 1rem;">
            <div v-for="(tasks, day, index) in formatDateWeekend" :key="day"
              class="kanban-collum-weekend"
              @dragover.prevent="onDragOver"
              @drop="onDrop(day, false, tasks, index+5)"
              >
              <div class="font-docs text-start d-flex justify-content-between w-100 mb-2" style="align-items: baseline;">
                <div class="column-header-text">
                  <span class="mr-1" style="color:#6C757D;"><b>{{ day.slice(0, 3) }}</b></span>
                  <span><b>{{ getDateForDay(index+5) }}</b></span>
                  <span v-if="isToday(index+5)" class="font-docs ml-1"> <b>(Hoje)</b></span>
                </div>
                <div>
                  <i class="fa-solid fa-plus" style="color:#6C757D; font-size: 14px; cursor:pointer" @click="CreateTask(index+5, 0)"></i>
                </div>
              </div>
              <div class="kanban-task-list">
                <transition-group name="move" tag="div">
                  <div
                    v-for="(task, tIndex) in tasks"
                    :key="tIndex"
                    class="task font-docs mb-2"
                    style="cursor: pointer;"
                    @click="selectDay(task)"
                    @dragstart="onDragStart(task, day)"
                    @dragover.prevent="onDragOverTask(task)"
                    @drop="onDrop(task, true)"
                    draggable="true"
                  >
                    <div v-if="task.situation" class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center">
                        <i v-if="task.situation !== '3'" class="fa-regular fa-circle-check mr-2" style="font-size: 12px;"></i>
                        <i v-if="task.situation === '3'" class="fa-solid fa-circle-check" style="font-size: 12px;"></i>
                        <Tag v-if="task.situation === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                          <span class="font-docs tag-text">À iniciar</span>
                        </Tag>
                        <Tag v-if="task.situation === '2'" rounded style='background-color: #CFF4FC;color: #087990;'>
                          <span class="font-docs tag-text">Em andamento</span>
                        </Tag>
                        <Tag v-if="task.situation === '4'" rounded style='background-color: #F8D7DA;color: #842029;'>
                          <span class="font-docs tag-text">Bloqueada</span>
                        </Tag>
                        <Tag v-if="task.situation === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                          <span class="font-docs tag-text">Concluída</span>
                        </Tag>
                      </div>
                      <div>
                        <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                        <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                        <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                      </div>
                    </div>
                    <div class="mb-3 mt-2 task-title">
                      <span v-if="task.situation !== '3'">{{ task.title }}</span>
                      <span v-if="task.situation === '3'"><s>{{ task.title }}</s></span>
                    </div>

                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center">
                        <div v-if="task.attachments && task.attachments.length >= 1" class="mr-2">
                          <i class="fa-solid fa-file-invoice mr-1" style="color:#ADB5BD; font-size: 12px;"></i>
                          <span style="color:#ADB5BD; font-size: 9px; font-weight: bold;">{{ task.attachments.length }}</span>
                        </div>
                      </div>

                      <div class="d-flex" v-if="task.users">
                        <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                            :key="user.id || uIdx"
                            :src="$userAvatar(user.path_image)"
                            alt="Avatar"
                            v-tooltip.top="user.name"
                            :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">

                        <div v-if="task.users.length > 2"
                            class="d-flex align-items-center justify-content-center"
                            style="width:20px; height: 20px; font-size: 9px; font-weight: bold; border:1px solid #3D8BFD; border-radius: 50%; background-color: #E7F1FF;">
                          <span class="font-docs" style="color: #3D8BFD;">+{{ task.users.length - 2 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
      </div>
    </template>

    <template v-if="viewMode === 'board'">
      <div class="kanban">
        <div class="board-columns">
          
          <div class="board-column" @dragover.prevent="onDragOver" @drop="onDropStatus('1')">
            <div class="d-flex align-items-center justify-content-between mb-3 px-1">
              <span class="font-docs column-header-text" style="color: #6C757D;">
                <i class="fa-regular fa-circle mr-1"></i> À INICIAR
              </span>
              <span class="badge badge-secondary" style="background-color: #ced4da; color: #495057;">{{ tasksByStatus.start.length }}</span>
            </div>
            <div class="kanban-task-list">
              <transition-group name="move" tag="div">
                <div
                  v-for="(task, index) in tasksByStatus.start"
                  :key="task.id || index"
                  class="task font-docs mb-2"
                  style="cursor: pointer;"
                  @click="selectDay(task)"
                  @dragstart="onDragStart(task, null)"
                  draggable="true"
                >
                  <div class="mb-2 mt-1 task-title">
                    {{ task.title }}
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                      <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                      <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                    </div>
                    <div class="d-flex" v-if="task.users">
                      <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                          :key="user.id || uIdx"
                          :src="$userAvatar(user.path_image)"
                          alt="Avatar"
                          v-tooltip.top="user.name"
                          :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>

          <div class="board-column" @dragover.prevent="onDragOver" @drop="onDropStatus('2')">
            <div class="d-flex align-items-center justify-content-between mb-3 px-1">
              <span class="font-docs column-header-text" style="color: #087990;">
                <i class="fa-solid fa-spinner mr-1"></i> EM ANDAMENTO
              </span>
              <span class="badge" style="background-color: #CFF4FC; color: #087990;">{{ tasksByStatus.executed.length }}</span>
            </div>
            <div class="kanban-task-list">
              <transition-group name="move" tag="div">
                <div
                  v-for="(task, index) in tasksByStatus.executed"
                  :key="task.id || index"
                  class="task font-docs mb-2"
                  style="cursor: pointer;"
                  @click="selectDay(task)"
                  @dragstart="onDragStart(task, null)"
                  draggable="true"
                >
                  <div class="mb-2 mt-1 task-title">
                    {{ task.title }}
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                      <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                      <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                    </div>
                    <div class="d-flex" v-if="task.users">
                      <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                          :key="user.id || uIdx"
                          :src="$userAvatar(user.path_image)"
                          alt="Avatar"
                          v-tooltip.top="user.name"
                          :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>

          <div class="board-column" @dragover.prevent="onDragOver" @drop="onDropStatus('4')">
            <div class="d-flex align-items-center justify-content-between mb-3 px-1">
              <span class="font-docs column-header-text" style="color: #842029;">
                <i class="fa-solid fa-ban mr-1"></i> BLOQUEADA
              </span>
              <span class="badge" style="background-color: #F8D7DA; color: #842029;">{{ tasksByStatus.bloqued.length }}</span>
            </div>
            <div class="kanban-task-list">
              <transition-group name="move" tag="div">
                <div
                  v-for="(task, index) in tasksByStatus.bloqued"
                  :key="task.id || index"
                  class="task font-docs mb-2"
                  style="cursor: pointer;"
                  @click="selectDay(task)"
                  @dragstart="onDragStart(task, null)"
                  draggable="true"
                >
                  <div class="mb-2 mt-1 task-title">
                    {{ task.title }}
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                      <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                      <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                    </div>
                    <div class="d-flex" v-if="task.users">
                      <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                          :key="user.id || uIdx"
                          :src="$userAvatar(user.path_image)"
                          alt="Avatar"
                          v-tooltip.top="user.name"
                          :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>

          <div class="board-column" @dragover.prevent="onDragOver" @drop="onDropStatus('3')">
            <div class="d-flex align-items-center justify-content-between mb-3 px-1">
              <span class="font-docs column-header-text" style="color: rgb(9 167 6);">
                <i class="fa-solid fa-circle-check mr-1"></i> CONCLUÍDA
              </span>
              <span class="badge" style="background-color: rgba(9,167,6,0.15); color: rgb(9 167 6);">{{ tasksByStatus.finish.length }}</span>
            </div>
            <div class="kanban-task-list">
              <transition-group name="move" tag="div">
                <div
                  v-for="(task, index) in tasksByStatus.finish"
                  :key="task.id || index"
                  class="task font-docs mb-2"
                  style="cursor: pointer;"
                  @click="selectDay(task)"
                  @dragstart="onDragStart(task, null)"
                  draggable="true"
                >
                  <div class="mb-2 mt-1 task-title">
                    <s>{{ task.title }}</s>
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <i v-if="task.priority === '1'" class="fa-solid fa-tag" style="color:#0D6EFD; font-size: 12px;"></i>
                      <i v-if="task.priority === '2'" class="fa-solid fa-tag" style="color:#FFC107; font-size: 12px;"></i>
                      <i v-if="task.priority === '3'" class="fa-solid fa-tag" style="color:#DC3545; font-size: 12px;"></i>
                    </div>
                    <div class="d-flex" v-if="task.users">
                      <img v-for="(user, uIdx) in task.users.slice(0, 2)"
                          :key="user.id || uIdx"
                          :src="$userAvatar(user.path_image)"
                          alt="Avatar"
                          v-tooltip.top="user.name"
                          :style="`height: 20px; width: 20px; border-radius: 50%; object-fit: cover; position: relative; left: ${uIdx}px;`">
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>

        </div>
      </div>
    </template>
  </div>

  <div v-if="Store.mobile">
    <ModalTask ref="ModalTaskRef" @taskDescription="handleTaskEdit"/>
    <ModalCreateTask ref="ModalCreateTaskRef" @CreateTask="handleTaskEdit"/>
    
    <div class="d-flex align-items-center mb-3">
      <i class="fa-solid fa-chevron-left mr-2" style="font-size: 24px; cursor:pointer" @click="voltarSemana()"></i>
      <i class="fa-solid fa-chevron-right mr-3" style="font-size: 24px; cursor:pointer" @click="avancarSemana()"></i>
      <span class="font-docs" style="font-size: 20px"><b>{{dateNow}}</b></span>
      <i class="fa-solid fa-arrows-rotate ml-3" style="font-size: 20px; cursor:pointer" @click="resetWeeks()"></i>
    </div>

    <div class="kanban">
      <div class="days">
        <div v-for="(tasks, day, index) in formatDateWeekMobile" :key="day"
          class="kanban-collum mb-3"
          @dragover.prevent="onDragOver"
          @drop="onDrop(day, false, tasks, index)"
          >
            <div class="font-docs text-start d-flex justify-content-between w-100 mb-2" style="align-items: baseline;">
              <div class="ml-2 column-header-text">
                <span class="mr-1" style="color:#6C757D;"><b>{{ day.slice(0, 3) }}</b></span>
                <span><b>{{ getDateForDay(index) }}</b></span>
                <span v-if="isToday(index)" class="font-docs ml-1"> <b>(Hoje)</b></span>
              </div>
              <div class="mr-1">
                <i class="fa-solid fa-plus" style="color:#6C757D; font-size: 14px; cursor:pointer" @click="CreateTask(index, 0)"></i>
              </div>
            </div>
          <div class="kanban-task-list">
            <transition-group name="move" tag="div" class="d-flex">
              <div
                v-for="(task, tIndex) in tasks"
                :key="tIndex"
                class="task font-docs mb-2"
                style="cursor: pointer;"
                @click="selectDay(task)"
                draggable="true"
              >
                <div v-if="task.situation" class="mt-2 mb-2 d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <Tag v-if="task.situation === '1'" rounded style='background-color: #E9ECEF;color:#6C757D;'>
                      <span class="font-docs tag-text">À INICIAR</span>
                    </Tag>
                    <Tag v-if="task.situation === '2'" rounded style='background-color: #CFF4FC;color: #087990;'>
                      <span class="font-docs tag-text">EM ANDAMENTO</span>
                    </Tag>
                    <Tag v-if="task.situation === '4'" rounded style='background-color: #F8D7DA;color: #842029;'>
                      <span class="font-docs tag-text">BLOQUEADA</span>
                    </Tag>
                    <Tag v-if="task.situation === '3'" rounded style='background-color: rgba(9,167, 6, 0.1);color: rgb(9 167 6);'>
                      <span class="font-docs tag-text">CONCLUÍDA</span>
                    </Tag>
                  </div>
                </div>
                <div class="mb-3 mt-2 task-title">
                  <span v-if="task.situation !== '3'">{{ task.title }}</span>
                  <span v-if="task.situation === '3'"><s>{{ task.title }}</s></span>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>